import { gsap } from 'gsap/all'
import Swiper, { Navigation, Scrollbar } from 'swiper'
import { store } from '../../src/js/core/store.js'
Swiper.use([Navigation, Scrollbar])

export const initNewsSlider = () => {
  const sliders = Array.from(document.querySelectorAll('.js-news-slider'))
  if (sliders.length <= 0) return false

  sliders.forEach(slider => {
    new Swiper(slider, {
      direction: 'horizontal',
      loop: false,
      spaceBetween: 10,
      watchOverflow: true,
      scrollbar: {
        el: slider.querySelector('.swiper-scrollbar'),
        draggable: true
      },
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next.news_next',
        prevEl: '.swiper-button-prev.news_prev'
      }
    })

    if (!store.isDevice) {
      // new Hovers(slider)
    }
  })
}

class Hovers {
  constructor (slider) {
    if (Array.from(slider.querySelectorAll('.js-tile')).length <= 0) { return false }
    this.tiles = []

    Array.from(slider.querySelectorAll('.js-tile')).forEach(tile => {
      this.tiles.push({
        tile,
        overlay: tile.querySelector('.js-overlay'),
        children: [...tile.querySelectorAll('.js-child')]
      })
    })

    this.bind()
  }

  enter (tile) {
    gsap.to(tile.overlay, 0.5, {
      y: '0%',
      ease: 'expo.out',
      opacity: 1,
      onStart: () => {
        tile.overlay.style.willChange = 'transform'
      },
      onComplete: () => {
        tile.overlay.style.willChange = 'unset'
      }
    })

    gsap.to(tile.children, 0.75, {
      y: '0%',
      delay: 0.25,
      opacity: 1,
      stagger: 0.1,
      ease: 'expo.out',
      onStart: () => {
        gsap.set(tile.children, { willChange: 'transform' })
      },
      onComplete: () => {
        gsap.set(tile.children, { willChange: 'unset' })
      }
    })
  }

  leave (tile) {
    gsap.to(tile.overlay, 0.5, {
      y: '-100%',
      ease: 'expo.out',
      onStart: () => {
        tile.overlay.style.willChange = 'transform'
      },
      onComplete: () => {
        tile.overlay.style.willChange = 'unset'
        gsap.set(tile.overlay, { y: '100%' })
      }
    })

    gsap.to(tile.children, 0.5, {
      y: '33px',
      opacity: 0,
      onStart: () => {
        gsap.set(tile.children, { willChange: 'transform' })
      },
      onComplete: () => {
        gsap.set(tile.children, { willChange: 'unset' })
      }
    })
  }

  bind () {
    this.tiles.forEach(tile => {
      tile.tile.addEventListener('mouseenter', () => {
        this.enter(tile)
      })

      tile.tile.addEventListener('mouseleave', () => {
        this.leave(tile)
      })
    })
  }
}
